(() => {
  const mount = () => document.querySelectorAll('[data-store-tabs]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const activate = (tab) => {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
      });
      // The existing hoodie slider needs its widths recalculated after unhiding.
      window.dispatchEvent(new Event('resize'));
    };
    root.querySelector('[role="tablist"]').hidden = false;
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next]);
        tabs[next].focus();
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
